import { getAPIBaseURL } from '@/config'
import type { FlexImage } from '@/libs/utilities/FlexImage'
import { generateFlexImage } from '@/libs/utilities/FlexImage'
import type { ImgixAvatarElement } from '@/apis/repositories/models/derek'

import type { PlannerID } from '@/types/app'

const imgixDomain = new URL(getAPIBaseURL('imgix')).host

// @workaround
// refs. https://github.com/400f/derek/blob/6fe6edf897ed5f27e9fa448aa64786f7e8e10d6d/app/models/planner_avatar.rb#L91-L103
const isDefaultIcon = (url: string): boolean =>
  /avatar\/0-default\/(?:male|female)\.png/.test(url)

export const createAvatarFromImgixAvatarElement = (
  plannerID: PlannerID,
  element: ImgixAvatarElement | null | undefined
): Maybe<FlexImage> =>
  element
    ? generateFlexImage(
        imgixDomain,
        `/avatar/${plannerID}/${element.uuid}.${element.ext}`
      )
    : undefined

export const createAvatarFromImgixPath = (path: string): FlexImage =>
  generateFlexImage(imgixDomain, path)

// NOTE: backward compatibility for derek
export const createAvatarFromImgixUrl = (imgixUrl: string): Maybe<FlexImage> =>
  !isDefaultIcon(imgixUrl)
    ? generateFlexImage(imgixDomain, new URL(imgixUrl).pathname)
    : undefined

// NOTE: we love this image https://okane-kenko-dev.imgix.net/avatar/1/8bfe8051-a919-4e73-be94-3809cdbc182e.jpg?ixlib=rb-3.1.1&w=160&h=160&q=70&fm=png32&mask=ellipse&fit=facearea&facepad=3
